import { ModalConfirmation, ModalProps, SectionMessage, useModalMultiple } from '@billy/design-system'
import { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../enums/modalId'

interface ConfirmDeleteConnectionModalProps extends ModalProps {
  removeConnection: () => void
}

export const ConfirmDeleteConnectionModal = ({ removeConnection }: ConfirmDeleteConnectionModalProps) => {
  const { t } = useTranslation()
  const { close: closeModal } = useModalMultiple([
    ModalId.BankConnectionRemoveConfirmationModal,
    ModalId.BankSettingsModal,
  ])

  const handleConfirmDeleteConnectionClick = useCallback(() => {
    removeConnection()
    closeModal(ModalId.BankSettingsModal)
    closeModal(ModalId.BankConnectionRemoveConfirmationModal)
  }, [closeModal, removeConnection])

  return (
    <ModalConfirmation
      danger
      id={ModalId.BankConnectionRemoveConfirmationModal}
      cancelLabel={t('back')}
      message={
        <>
          <Trans i18nKey="bank_connection.confirm_disconnect_info" components={{ strong: <strong />, br: <br /> }} />
          <SectionMessage variant="neutral" icon="lightbulb">
            <Trans
              i18nKey="bank_connection.confirm_disconnect_callout"
              components={{ strong: <strong />, br: <br /> }}
            />
          </SectionMessage>
        </>
      }
      okLabel={t('bank_connection.confirm_disconnect_yes')}
      onOk={handleConfirmDeleteConnectionClick}
      title={t('bank_connection.confirm_disconnect_title')}
    />
  )
}
